import { connect } from 'react-redux';

import { SuggestionBarActions } from '../actions';
import SuggestionBar from '../components/SuggestionBar';

export default connect(
  null,
  { onClose: SuggestionBarActions.hide },
)(SuggestionBar);
